/**
 * Shared spherical-coordinate helpers for globe primitives.
 *
 * Convention matches the Globe/Arc renderers: latitude in degrees [-90, 90],
 * longitude in degrees [-180, 180], mapped onto a sphere of the given radius.
 */

import { Vector3 } from 'three';

/** Project a (lat, lon) pair onto a point on a sphere of the given radius. */
export function latLonToVec3(lat: number, lon: number, radius: number): Vector3 {
  const phi = (90 - lat) * (Math.PI / 180);
  const theta = (lon + 180) * (Math.PI / 180);
  return new Vector3(
    -radius * Math.sin(phi) * Math.cos(theta),
    radius * Math.cos(phi),
    radius * Math.sin(phi) * Math.sin(theta),
  );
}
